module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knife-field"
  }, [_c(_vm.type, {
    tag: "component",
    attrs: {
      "value": _vm.value,
      "fields": _vm.table.fields,
      "data-list": _vm.table.dataList,
      "len": _vm.len,
      "slots": _vm.listSlots
    },
    on: {
      "change": _vm.changeVal,
      "choose": _vm.chooseVal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14704b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KField.vue
// module id = 114
// module chunks = 1